var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      attrs: { trigger: "click" },
      on: { "visible-change": _vm.dropDownIcon, command: _vm.handleCommand },
    },
    [
      _c(
        "span",
        { staticClass: "el-dropdown-link", class: { bold: _vm.isBold } },
        [
          _c("pp-icon", {
            staticClass: "mgr5",
            attrs: { type: "ios-world-outline", size: "20" },
          }),
          _vm._v(" " + _vm._s(_vm.textFont[_vm.lang]) + " "),
          _c("i", { class: _vm.textIcon }),
        ],
        1
      ),
      _c(
        "el-dropdown-menu",
        {
          staticClass: "lang-dropdown",
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        [
          _c("el-dropdown-item", { attrs: { command: _vm.elseKey } }, [
            _vm._v(_vm._s(_vm.textFont[_vm.elseKey])),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }